import React from 'react';
import { Box, Button, Flex, HStack, Text, useDisclosure, IconButton, Stack, useBreakpointValue, VStack } from '@chakra-ui/react';
import { Menu, X } from 'lucide-react';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import posthog from 'posthog-js';

const Header = () => {
  const { open, onOpen, onClose } = useDisclosure();
  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <Box as="header" position="fixed" w="100%" bg="white" boxShadow="sm" zIndex={10}>
      <Flex h={16} alignItems="center" justifyContent="space-between" maxW="1200px" mx="auto" px={4}>
        <HStack gap={8} alignItems="center">
          <Box>
            <Text textStyle="subheading" fontWeight="bold" color="brand.secondary">DIYBuddy</Text>
          </Box>
        </HStack>
        
        {!isMobile ? (
          <Flex alignItems="center">
            <HStack as="nav" gap={4} display={{ base: 'none', md: 'flex' }}>
              <ScrollLink to="features" smooth={true} duration={500} offset={-80}>
                <Button 
                  variant="ghost" 
                  colorScheme="gray"
                  onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'features', view: 'desktop' });
                  }}
                >
                  Features
                </Button>
              </ScrollLink>
              <ScrollLink to="how-it-works" smooth={true} duration={500} offset={-80}>
                <Button 
                  variant="ghost" 
                  colorScheme="gray"
                  onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'how-it-works', view: 'desktop' });
                  }}
                >
                  How It Works
                </Button>
              </ScrollLink>
              <ScrollLink to="use-cases" smooth={true} duration={500} offset={-80}>
                <Button 
                  variant="ghost" 
                  colorScheme="gray"
                  onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'use-cases', view: 'desktop' });
                  }}
                >
                  Use Cases
                </Button>
              </ScrollLink>
              {/* <ScrollLink to="waitlist" smooth={true} duration={500} offset={-80}>
              <Button 
                ml={4} 
                variant="solid"
                color="white"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'waitlist', view: 'desktop', action: 'join_waitlist' });
                  }}
              >
                Join Waitlist
              </Button>
            </ScrollLink> */}
              <RouterLink to="/app">
                <Button 
                  variant="outline"
                  onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'diy-buddy', view: 'desktop' });
                  }}
                >
                  <VStack align="center" justify="center" gap={0.5}>
                    <Text textAlign="center" lineHeight="1">Try the App!</Text>
                    <Text fontSize="xs" color="gray.500" fontWeight="light" textAlign="center" lineHeight="1">Currently in Alpha</Text>
                  </VStack>
                </Button>
              </RouterLink>
            </HStack>
          </Flex>
        ) : (
          <IconButton
            size="md"
            aria-label={open ? 'Close menu' : 'Open menu'}
            onClick={open ? onClose : onOpen}
            display={{ base: 'flex', md: 'none' }}
            variant="ghost"
            color="black"
          >
            {open ? <X size="1.5em" color="black" /> : <Menu size="1.5em" color="black" />}
          </IconButton>
        )}
      </Flex>

      {/* Mobile menu */}
      {open && isMobile && (
        <Box pb={4} px={4} bg="white">
          <Stack as="nav" gap={4}>
            <ScrollLink to="features" smooth={true} duration={500} offset={-80} onClick={onClose}>
              <Button 
                w="full" 
                variant="outline" 
                justifyContent="flex-start"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'features', view: 'mobile' });
                  }}
              >
                Features
              </Button>
            </ScrollLink>
            <ScrollLink to="how-it-works" smooth={true} duration={500} offset={-80} onClick={onClose}>
              <Button 
                w="full" 
                variant="ghost" 
                justifyContent="flex-start"
                color="black"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'how-it-works', view: 'mobile' });
                  }}
              >
                How It Works
              </Button>
            </ScrollLink>
            <ScrollLink to="use-cases" smooth={true} duration={500} offset={-80} onClick={onClose}>
              <Button 
                w="full" 
                variant="ghost" 
                justifyContent="flex-start"
                color="black"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'use-cases', view: 'mobile' });
                  }}
              >
                Use Cases
              </Button>
            </ScrollLink>
            <RouterLink to="/app" onClick={onClose}>
              <Button 
                w="full" 
                variant="ghost" 
                justifyContent="flex-start"
                color="black"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'diy-buddy', view: 'mobile' });
                  }}
              >
                DIY Buddy
              </Button>
            </RouterLink>
            <ScrollLink to="mailinglist" smooth={true} duration={500} offset={-80} onClick={onClose}>
              <Button 
                w="full" 
                variant="solid"
                colorScheme="primary"
                onClick={() => {
                    console.log('Navigation click event');
                    posthog.capture('nav_click', { section: 'mailinglist', view: 'mobile', action: 'join_waitlist' });
                  }}
              >
                Stay Updated
              </Button>
            </ScrollLink>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default Header;
